import React from 'react'
import NavMenuItem from './NavMenuItem'
import {
  NavItem,
  INavItemListProps,
} from '../../../interfaces/Navigation.Interface'

const NavItemsList = ({ navItems }: INavItemListProps) => (
  <ul>
    {navItems.map((item: NavItem, index) => {
      return <NavMenuItem key={index} {...item}></NavMenuItem>
    })}
  </ul>
)

export default NavItemsList
